// Lo que comparten TODAS las páginas del sitio. Cada entrada (src/<pagina>.tsx)
// lo importa primero: estilos, GA4, seguimiento de descargas y aviso de cookies.
import { createRoot } from 'react-dom/client';
import './index.css';
import AvisoCookies from './components/AvisoCookies';
import { activarSeguimientoDescargas, iniciarAnalytics } from './lib/analytics';

iniciarAnalytics();
activarSeguimientoDescargas();

// El aviso se monta en su propio contenedor, aparte del contenido de la página.
const contenedorAviso = document.createElement('div');
contenedorAviso.id = 'aviso-cookies';
document.body.appendChild(contenedorAviso);
createRoot(contenedorAviso).render(<AvisoCookies />);
